import { useNavigate } from "react-router-dom";
import { usePresentationsList } from "@/lib/presentationQueries";

/**
 * Presentations/Presence Contexts — workspace-wide, not member-scoped
 * (PresentationProject carries no owner_member_id of its own — see
 * presentation_contracts.py), so this reuses the existing per-workspace
 * list exactly as-is.
 */
export default function PresentationsTab({ workspaceId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = usePresentationsList(workspaceId);

  return (
    <div data-testid="client-360-presentations-tab">
      <div className="flex justify-end mb-3">
        <button
          onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/presentation`)}
          className="text-xs text-terracotta hover:underline"
          data-testid="client-360-presentations-open-full-page"
        >
          Open full Presentations workbench →
        </button>
      </div>
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-presentations-loading">Loading…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="client-360-presentations-error">Couldn't load presentations.</p>
      ) : data.items?.length === 0 ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-presentations-empty">No Presentations in this Workspace yet.</p>
      ) : (
        <div className="space-y-2" data-testid="client-360-presentations-list">
          {(data.items || []).map((p) => (
            <button
              key={p.pres_id}
              onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/presentation/${p.pres_id}`)}
              className="w-full text-left border border-ink/10 rounded-lg p-3 bg-white/50 hover:bg-ink/5 transition-colors flex items-center justify-between gap-3"
              data-testid={`client-360-presentation-${p.pres_id}`}
            >
              <span className="text-sm text-ink font-medium">{p.title}</span>
              <span className="text-xs text-ink-soft uppercase shrink-0">{p.status}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
